import { FormGroup } from '@angular/forms';

export class JobApplication {
    public id: string;
    public jobId: string;
    public name: string;
    public email: string;
    public phone: string;
    public jobTitle: string;
    public salary: number;
    public coverLetter: string;
    public accountId: string;
    public cvPath: string;

    public static parse(form: FormGroup): JobApplication {
        let jobApplication = new JobApplication();
        Object.assign(jobApplication, form.value);
        if(!form.value.salary) {
            jobApplication.salary = null;
        } else {
            jobApplication.salary = Number.parseInt(form.value.salary);
        }
        return jobApplication;
    }
}
